module.exports = __webpack_public_path__ + "static/media/aajubaajuRecognitions.fcd6e613.jpg";